/*
    Developer Name :
    Developed Date :
    Page Name      : Radiology print page
    Created        :
    Last Edited By : Raja
    Edited Date    : 29.09.2021
    Last Edited    : implemented printersettings based on print radiology
*/
import { Component, Input, OnInit } from '@angular/core';


// import printer settings implement by RAJA :) 29-09-21
import { DOCUMENT } from '@angular/common';
import { Inject } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment'; 
import { RadiologyEhrData } from '../../../../@core/interfaces/ehr/radiology-ehr';
import { imageatch_detData } from '../../../../@core/interfaces/masters/imageatch_det'; 
import { PrinterSettings, PrinterSettingsData } from '../../../../@core/interfaces/masters/printersettings'; 
import { PrintServiceService } from '../service/print-service.service'; 
// import ps end by RAJA :) 29-09-21
import * as dwv from 'dwv';


// gui overrides

// get element
dwv.gui.getElement = dwv.gui.base.getElement;
dwv.gui.prompt = dwv.gui.base.prompt;

// Image decoders (for web workers)
dwv.image.decoderScripts = {
  jpeg2000: 'assets/dwv/decoders/pdfjs/decode-jpeg2000.js',
  'jpeg-lossless': 'assets/dwv/decoders/rii-mango/decode-jpegloss.js',
  'jpeg-baseline': 'assets/dwv/decoders/pdfjs/decode-jpegbaseline.js',
  rle: 'assets/dwv/decoders/dwv/decode-rle.js'
};

@Component({
  selector: 'ngx-radiology-print',
  templateUrl: './radiology-print.component.html',
  styleUrls: ['./radiology-print.component.scss']
})
export class RadiologyPrintComponent implements OnInit {

  @Input() data:any;

  // Input get by Abirami P
  @Input() imgname:any;

//private tenantId = environment.tenantId;
 // private branchId = environment.branchId;
 private tenantId = localStorage.getItem("tenantId");
  private branchId = localStorage.getItem("branchId");
   


// printer settings variable declare start by RAJA :) 29-09-21
styleUrl="/assets/css/print.css,/assets/css/a4portrait.css";
srcname="../.././../../assets/images/white.png";
psDetails:PrinterSettings;
pageName="Radiology"; //Radiology
// printer settings variable declare end by RAJA :) 29-09-21
patientDetailes:any={
  patientName:'',
  patientAgeGender:'',
  patientCity:'',
  patientMobileNUmber:'',
  regNumber:'',
}
allImages:any=[];
resultData:any=[];
previousoption:boolean=true;
  nextoption:boolean=true;
  protected readonly unsubscribe$ = new Subject<void>();

  constructor(    
    // printer settings constructor object create start by RAJA :) 29-09-21
    private iatchSrvc: imageatch_detData,
    protected psSrvc:PrinterSettingsData,
    public PrintServiceService:PrintServiceService,
    @Inject(DOCUMENT) public document: any,
    private radiologySrvc: RadiologyEhrData, 
    // printer settings constructor object create end by RAJA :) 29-09-21

  ) { }

  ngOnInit(): void {
  

    
     // printer settings function call start by Raja :) 29-09-21
     this.loadPSF();
     this.loadImg();
     // printer settings function call end by Raja :) 29-09-21 
     this.loadPatientDetails();
  }


  loadPatientDetails(){
    var datas=this.data.patientRegistrationMst;
    var _patdetailes={
      patientName:datas?.firstname,
      patientAgeGender:datas?.gender,
      patientCity:datas?.city,
      patientMobileNUmber:datas?.mobile,
      regNumber:datas?.regNum,
    }
    this.patientDetailes=_patdetailes;
  }
  async ngAfterViewInit(): Promise<void> { 
    await this.sleep(1000);
    // this.loadImages();

  }
// loadImages(){
 

//   this.allImages=[];
//   for(var i=0;i<this.imagesList?.length;i++){
//     if(this.imagesList[i]?.fileName.indexOf(".dcm") > -1){

//     }else{
        
//       this.onView(this.imagesList[i]);
//     }
//   }
  
// }
  sleep(ms) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }
  // onView(det): void {
  //  if ((det.fileName as string).indexOf(".jpg") > -1 || (det.fileName as string).indexOf(".png") > -1 || (det.fileName as string).indexOf(".jpeg"))
  //   {
  //     det.isCreate=true;
  //     det.isEdit=true;
  //     det.isView=true;
      
  //     this.radiologySrvc.create(`${this.getApiUrl}/AtchDet/${this.tenantId}/${this.branchId}/download`,det).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      
    
  //        var imgname = 'data:image/jpeg;base64,' + data;
       

  //        this.allImages.push({data:det,img:imgname});
     
        
  //       //  Function called by Abirami P
  //        this.getradiologuvalue();   
  //     }, (error) => {
  
  //     }, () => {
  
  //     });
    

  //   }
  // }
  
  get getApiUrl(): string {
    return environment.apiUrl;
  }

  
  // function implemented printer settings start by Raja :) 29-09-21
  loadPSF()
  {
    // call api load printer settings
    this.psSrvc.list(this.tenantId +"/"+this.branchId+ "/printersettings").pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      var ps=data.filter(ps=>ps.pageSetupFor==this.pageName)
      // set printer settings data
        if(ps.length>0){
          this.psDetails=ps[0];
          // dynamic set style url based on papper size
          this.styleUrl="/assets/css/print.css,/assets/css/"+(this.psDetails.paperSize).toLowerCase()+(this.psDetails.orientation).toLowerCase()+".css";
          // set header and footer position & required
          this.psDetails=this.PrintServiceService.onSetPsData(this.psDetails);
          // end
        }else{
            this.psDetails=this.PrintServiceService.onGetPrinterSettings();
        } 
      }, (error) => {
      }, () => {
      });

  }

  // load tenant img  ***********  Raja
  loadImg(){
      this.iatchSrvc.getById(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/logo`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
           
        this.srcname="../.././../../assets/images/white.png"
        this.iatchSrvc.create(`${environment.apiUrl}/ImageAtchDet/${this.tenantId}/${this.branchId}/download`,data[0]).pipe(takeUntil(this.unsubscribe$)).subscribe((downloaddata: any) => {
        
          this.srcname = 'data:image/jpeg;base64,' + downloaddata;
        }, (error) => {

        }, () => {

        });

    }, (error) => {

    }, () => {

    });

    }
// function implemented printer settings end by Raja :) 29-09-21


// Function declaration start by Abirami P
// To find data based on index value:
  // getradiologuvalue() {
  //   this.resultData = [];
  //   this.allImages.forEach(i => {
  //     if (i == this.radiologyindex) {
  //       this.resultData.push(this.allImages[i]);
  //     }
  //   });
  // }

// To get previous record based on current index value:-
// previousClick(){
//   this.radiologyindex-=1;
//   if(this.radiologyindex<0){
//     this.radiologyindex=this.allImages.length-1;
//   }
//   this.getradiologuvalue();
// }

// To get next record based on current index value:-
// nextClick(){
//   this.radiologyindex+=1;
//   if(this.allImages.length-1<this.radiologyindex){
//     this.radiologyindex=0;
//   }
//   this.getradiologuvalue();

// }
// Function declaration end by Abirami P

}
